import React from 'react'
import './Dashboardhome.css'

function Dashboardhome() {
  return (
      <>
          <div>        
<img className='center'  width="70%" src="https://media4.giphy.com/media/3oKIPEqDGUULpEU0aQ/giphy.gif" alt="" />      
          </div>
          
          
      </>
  )
}

export default Dashboardhome